import { render, staticRenderFns } from "./GrupaNDA.vue?vue&type=template&id=16d616ad&scoped=true&"
import script from "./GrupaNDA.vue?vue&type=script&lang=js&"
export * from "./GrupaNDA.vue?vue&type=script&lang=js&"
import style0 from "./GrupaNDA.vue?vue&type=style&index=0&id=16d616ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d616ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d616ad')) {
      api.createRecord('16d616ad', component.options)
    } else {
      api.reload('16d616ad', component.options)
    }
    module.hot.accept("./GrupaNDA.vue?vue&type=template&id=16d616ad&scoped=true&", function () {
      api.rerender('16d616ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Drawers/GrupaNDA.vue"
export default component.exports